import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import SPOT_CONSTANTS from '../constants/SpotConstants';

/**
 * 🔒 Premium Radius Payment Modal
 * Shop 티켓 구매 팝업 스타일 적용
 */

const PremiumRadiusModal = ({ isOpen, onConfirm, onCancel }) => {
    const { t } = useTranslation();

    if (!isOpen) return null;

    const cost = SPOT_CONSTANTS.PREMIUM_RADIUS.COST;

    return (
        <Overlay>
            <ModalBox>
                {/* Header */}
                <Header>
                    <Title>{t('premium_radius_title')}</Title>
                </Header>

                {/* Body */}
                <Body>
                    <Question>{t('premium_radius_desc')}</Question>

                    {/* Price Box */}
                    <PriceBox>
                        <PriceLabel>{t('spot_final_payment_amount')}</PriceLabel>
                        <PriceValue>⭐ {cost}</PriceValue>
                    </PriceBox>

                    {/* Warning */}
                    <Warning>{t('premium_radius_warning')}</Warning>
                </Body>

                {/* Footer Buttons */}
                <Footer>
                    <Button $variant="cancel" onClick={onCancel}>
                        {t('spot_cancel')}
                    </Button>
                    <Button $variant="confirm" onClick={onConfirm}>
                        {t('spot_confirm')}
                    </Button>
                </Footer>
            </ModalBox>
        </Overlay>
    );
};

export default PremiumRadiusModal;

// 🎨 Styled Components (Shop Modal Style)

const Overlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.6);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
    padding: 20px;
`;

const ModalBox = styled.div`
    background: #f5f5f5;
    border-radius: 16px;
    max-width: 320px;
    width: 100%;
    overflow: hidden;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
`;

const Header = styled.div`
    background: white;
    padding: 16px 20px;
    display: flex;
    align-items: center;
    gap: 10px;
    border-bottom: 1px solid #e0e0e0;
`;

const Icon = styled.span`
    font-size: 24px;
`;

const Title = styled.h3`
    margin: 0;
    font-size: 16px;
    font-weight: 600;
    color: #333;
`;

const Body = styled.div`
    padding: 30px 20px;
    text-align: center;
`;

const CenterIcon = styled.div`
    margin-bottom: 20px;
`;

const Question = styled.p`
    font-size: 15px;
    color: #333;
    margin: 0 0 20px 0;
    line-height: 1.5;
    font-weight: 500;
`;

const PriceBox = styled.div`
    background: #e8e8e8;
    border-radius: 8px;
    padding: 14px 18px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
`;

const PriceLabel = styled.span`
    font-size: 13px;
    color: #666;
    font-weight: 500;
`;

const PriceValue = styled.span`
    font-size: 16px;
    color: #FFA500;
    font-weight: 700;
`;

const Warning = styled.p`
    font-size: 11px;
    color: #888;
    margin: 0;
    line-height: 1.4;
    text-align: left;
`;

const Footer = styled.div`
    display: flex;
    gap: 0;
    border-top: 1px solid #e0e0e0;
`;

const Button = styled.button`
    flex: 1;
    padding: 16px;
    font-size: 15px;
    font-weight: 600;
    border: none;
    cursor: pointer;
    transition: all 0.2s;

    ${props => props.$variant === 'cancel' && `
        background: #d0d0d0;
        color: #666;

        &:hover {
            background: #c0c0c0;
        }

        &:active {
            background: #b0b0b0;
        }
    `}

    ${props => props.$variant === 'confirm' && `
        background: #FFC107;
        color: #333;

        &:hover {
            background: #FFB300;
        }

        &:active {
            background: #FFA000;
        }
    `}
`;
